import React from 'react';
import { useAccessibilityPreferences } from '../../hooks/useAccessibility';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  label = 'Loading',
}) => {
  const { reducedMotion } = useAccessibilityPreferences();

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  const animationClass = reducedMotion ? '' : 'animate-spin';

  return (
    <div 
      className={`${animationClass} ${sizeClasses[size]} ${className}`} 
      role="status" 
      aria-label={label}
    >
      <svg
        className="w-full h-full"
        style={{ color: 'var(--color-primary)' }}
        fill="none"
        viewBox="0 0 24 24"
        aria-hidden="true"
      >
        <circle
          className="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="4"
        />
        <path
          className="opacity-75"
          fill="currentColor"
          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        />
      </svg>
      <span className="sr-only">{label}</span>
    </div>
  );
};

interface LoadingPageProps {
  message?: string;
}

export const LoadingPage: React.FC<LoadingPageProps> = ({
  message = 'Loading...',
}) => {
  return (
    <div 
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: 'var(--color-background)' }}
    >
      <div className="text-center">
        <LoadingSpinner size="lg" className="mx-auto mb-4" label={message} />
        <p 
          style={{ color: 'var(--color-text-secondary)' }}
          aria-live="polite"
        >
          {message}
        </p>
      </div>
    </div>
  );
};